import { h, render, Component } from "preact";
import Modal from "../../components/Modal";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "preact/hooks";
import { http as fetch } from "./../../auth";

const ComponentModal = ({
  activeModal,
  handleClose,
  reloadPage,
  id = null,
}) => {
  const { register, handleSubmit, reset, setValue, getValues } = useForm();
  const [data, setData] = useState("");
  const isAddMode = !id;

  useEffect(() => {
    reset();
    if (!isAddMode) {
      fetch("/api/components/" + id)
        .then((res) => {
          if (res.ok) return res.json();
          return Promise.reject(res);
        })
        .then((res) => {
          const fields = ["name"];
          fields.forEach((field) => setValue(field, res[field]));
        });
    }
  }, [id]);

  const onSubmit = (data) => {
    const url = "";
    fetch(`/api/components/${isAddMode ? "" : id}`, {
      method: isAddMode ? "POST" : "PUT",
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) return res.json();
        return Promise.reject(res);
      })
      .then((res) => {
        reset();
        reloadPage();
        handleClose();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal
      active={activeModal}
      onClose={handleClose}
      title={isAddMode ? "Crear componente" : "Editar componente"}
    >
      <form id="form" onSubmit={handleSubmit(onSubmit)}>
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              {...register("name")}
              class="input"
              type="text"
              placeholder=""
              required
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ComponentModal;
